export default function UserXpLevelIcon({ levelName, size = 32, ...props }) {
	return (
		<div
			style={{
				width: size,
				height: size,
				backgroundImage: "url(/assets/icons/xp-level-badge.svg)",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				color: "white",
				fontWeight: "bold",
				fontSize: `${size * 0.5}px`,
				textAlign: "center",
				...props.style,
			}}
			{...props}
		>
			{levelName}
		</div>
	);
}
